<template>
  <div class="pr-md-24">
    <div class="d-flex justify-end mb-2">
      <v-btn tile color="primary" @click="$router.push({ name: 'user-index' })">
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card class="pl-0 pl-md-4 mb-10 pr-md-24" elevation="0" outlined>
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
        class="pa-2"
        @submit.prevent="editUser"
        v-if="user"
      >
        <v-row class="text-center">
          <v-col class="text-center" cols="12" md="6">
            <image-picker
              v-model="user.avatar"
              :uploaded="user.avatar !== null"
              :add="user.avatar === null"
              @delete-item="user.avatar = null"
              @reset="user.avatar = null"
              class="mb-5"
            >
              <div slot="activator" class="cursor-pointer w-100 h-100">
                <img
                  :src="user.avatar"
                  alt="avatar"
                  height="100%"
                  v-if="user.avatar"
                />
              </div>
            </image-picker>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12">
            <h2 class="group-label col-12 text-left px-0">
              General Information
            </h2>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              label="First Name"
              outlined
              v-model="user.firstName"
              :rules="nameRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="20"
              outlined
              label="Last Name"
              v-model="user.lastName"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :counter="35"
              outlined
              label="Email"
              v-model="user.email"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.userPositionId"
              :items="userPositions"
              outlined
              label="Select Position"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <hr />
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              v-model="user.active"
              inset
              label="Active/Inactive"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              v-model="user.approved"
              inset
              label="Approved/Unapproved"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.type"
              :items="types"
              :rules="typeRules"
              outlined
              label="Select Type"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="user.role"
              :items="roles"
              :rules="roleRules"
              outlined
              label="Select Roles"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" v-if="user.type === 'supplier'">
            <v-autocomplete
              v-model="user.supplier.id"
              :items="suppliers"
              outlined
              label="Select Supplier"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" v-if="user.type === 'surgery'">
            <v-text-field
              :counter="35"
              label="GDC Number"
              outlined
              type="number"
              v-model="user.gdcNumber"
              :rules="gdcRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="user.type === 'surgery'">
            <v-autocomplete
              v-model="user.surgery.id"
              :items="surgeries"
              outlined
              label="Select Surgery"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col> </v-col>
          <v-col cols="12">
            <hr />
          </v-col>
          <v-col cols="12">
            <address-list :payload="{ from: 0, to: 10, userId: id }" />
          </v-col>
          <v-col cols="12">
            <hr />
          </v-col>
          <v-col cols="12">
            <phone-list :payload="{ from: 0, to: 10, userId: id }" />
          </v-col>
          <v-col cols="12" md="6" class="text-left">
            <v-btn type="submit" color="accent" class="mx-0 mt-4 font-bold"
              >SAVE</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import AddressList from "@/components/user_management/address/AddressList.vue";
import PhoneList from "@/components/user_management/phone/PhoneList.vue";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  props: ["id"],
  data() {
    return {
      valid: false,
      types: ["employee", "surgery", "supplier"],
      roles: ["admin", "user"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than than 15 characters"
      ],
      gdcRules: [
        v => !!v || "GdcNumber is required",
        v => v.length >= 8 || "Phone must be at least 8 digits",
        v => v.length <= 20 || "Phone must be less than than 20 digits"
      ],
      typeRules: [v => !!v || "Type is required"],
      roleRules: [v => !!v || "Role is required"]
    };
  },
  components: {
    AddressList,
    PhoneList,
    ImagePicker
  },
  async mounted() {
    await this.$store.dispatch("users/LOAD_USER_POSITIONS");
    await this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
    await this.$store.dispatch("users/LOAD_USER", {
      userId: this.id
    });
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
      userPositions: state => state.users.user_positions,
      suppliers: state => state.suppliers.suppliers,
      surgeries: state => state.surgeries.surgeries
    })
  },
  methods: {
    async editUser() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating user...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("users/UPDATE_USER", this.user);
      }
    }
  }
};
</script>
